// extracted by mini-css-extract-plugin
module.exports = {"EstimateHeader":"Page_EstimateHeader__lVu_a","EstimateHeaderTitle":"Page_EstimateHeaderTitle__aiQgc"};